<template>
    <div class="wrap-tabs">
        <div class="wrap-tabs__content earn-turn">
            <div v-for="(item, index) in eventWorldcupInfo.listEarnTurn" :key="index" class="earn-turn__item" :class="{'hide': item.isShowNotLogin && isLogin}">
                <a v-if="!item.isShowNotLogin || !isLogin" href="javascript:void(0)"  @click="MoveTo(item)" class="earn-turn__item-wrap">
                    <img :src="item.thumb" :alt="item.title">
                </a>
            </div>
        </div>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import { eventWorldcupInfo } from '@/resources/worldcup/worldcup';

export default {
    data() {
        return {
            isLogin: false,
            eventWorldcupInfo
        };
    },
    methods: {
        backgroundDevice() {
            if (this.$isMobile()) {
                return '/assets/img/event/seagame/tabs/bg-earn-turn-mb.png';
            }
            return '/assets/img/event/seagame/tabs/bg-earn-turn.png';
        },
        MoveTo(item) {
            if (item.func === 'login') {
                this.$bvModal.show('loginModal');
            }
            if (item.func === 'bet') {
                this.$router.push('/the-thao');
            }
            if (item.func === 'deposit') {
                if (this.currentUser) {
                    this.$router.push('/user/deposit?tab=index');
                } else {
                    this.$bvModal.show('loginModal');
                }
            }
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        }
    },
    mounted() {
        if (this.currentUser !== null) {
            this.isLogin = true;
        } else {
            this.isLogin = false;
        }
    }
};
</script>
